export default __webpack_public_path__ + "static/media/bg-img-02.44ee82b2.svg";